import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import RecaptchaInvisible from '@core/components/recaptcha/RecaptchaInvisible.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(RecaptchaInvisible.name, RecaptchaInvisible)
